import { createRouter } from '@tanstack/react-router';
import { createShortUrlRewrite } from '@hlt/web-kit/shell';
import type { QueryClient } from '@tanstack/react-query';
import { routeTree } from '@/routeTree.gen';

export interface RouterContext {
    queryClient: QueryClient;
}

export function createAppRouter(queryClient: QueryClient) {
    return createRouter({
        routeTree,
        context: { queryClient },
        // Pointing at, focusing or touching a link loads the page's code and starts its main read (route
        // loaders); a short delay skips links the pointer only passes over.
        defaultPreload: 'intent',
        defaultPreloadDelay: 30,
        // Short addresses (`/w/<workspace>/audits/<audit>`); older addresses with the organization or with
        // UUIDs still open. Routes and API calls keep using UUIDs.
        rewrite: createShortUrlRewrite({ dropOrganization: true }),
        scrollRestoration: true,
        defaultPendingMs: 400,
    });
}

declare module '@tanstack/react-router' {
    interface Register {
        router: ReturnType<typeof createAppRouter>;
    }
}
